export { default as Home } from './Home/Home';
export { default as About } from './About/About';
export { default as Services } from './Services/Services';
